export default __webpack_public_path__ + "static/media/logo-white.f5263cf0.png";